import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { Note, NOTE_TYPE } from "../../../../components/note/note";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";

import "./return-guard-description-variables.scss";

const ReturnGuardDescriptionVariables: React.FC<{ scope: string }> = ({ scope }) => {
    const { getTranslation } = useDashboardTranslation();

    return (
        <Note
            type={NOTE_TYPE.INFORMATION}
            body={<>
                <FontBody2 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>
                    {getTranslation('VARIABLES', scope)}
                </FontBody2>
                <div>
                    {getTranslation('COVERAGE_DESCRIPTION_VARIABLES_DESCRIPTION', scope)}
                </div>
                <ul className="variables-list-description mb-0 mt-0">
                    <li>{getTranslation('COVERAGE_DESCRIPTION_VARIABLES_PRICE', scope)}</li>
                </ul>
            </>}
        />
    );
};

export default ReturnGuardDescriptionVariables;
